import { useEffect, useState } from "react";
import { readWhatsAppTemplateHeaderFormat, type WhatsAppTemplateDto } from "@multi-chat/shared";
import { createWhatsAppTemplateHeaderImageDownloadUrl } from "../../api/whatsapp-api.js";

export function templateHasStoredHeaderImage(
  template: Pick<WhatsAppTemplateDto, "components" | "headerMedia" | "headerImageMissing"> | null,
): boolean {
  return (
    template != null &&
    template.headerMedia != null &&
    template.headerImageMissing !== true &&
    readWhatsAppTemplateHeaderFormat(template.components) === "IMAGE"
  );
}

export function useWhatsAppTemplateHeaderImageUrl(
  organizationId: number | null,
  templateId: number | null,
  enabled: boolean,
): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || organizationId == null || templateId == null) {
      setUrl(null);
      return;
    }
    const controller = new AbortController();
    void createWhatsAppTemplateHeaderImageDownloadUrl(
      organizationId,
      templateId,
      controller.signal,
    )
      .then((response) => {
        if (!controller.signal.aborted) setUrl(response.url);
      })
      .catch(() => {
        if (!controller.signal.aborted) setUrl(null);
      });
    return () => controller.abort();
  }, [enabled, organizationId, templateId]);

  return url;
}
